 
    export const formatDate1 = (date) =>{
      let index = date;
      index = index.split("-");
      let formatedDate = index[2] +"/"+ index[1] +"/"+ index[0]; 
          return(formatedDate);
      }
  

export default formatDate1;